import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ICustomizationAnswer, ICustomizationQuestion } from '../../../store/slices/customization/customization';

interface Props {
  foregroundColor: string;
  backgroundColor: string;
  answer: ICustomizationAnswer;
  question: ICustomizationQuestion;
}

class HeatmapStyle extends Component<Props> {
  render() {
    const { foregroundColor, backgroundColor, answer, question } = this.props;
    return (
      <style type="text/css" scoped>
        {`
          .heatmapNumber {
            background-color: ${foregroundColor};
          }
          .heatmapImage {
            background-color: ${backgroundColor};
          }
          .heatmap-modal .heatmap-option {
            background-color: white;
            font-family: ${answer.font};
            color: #000000;
          }
          .heatmap-option.selected,
          .heatmap-option.selected:focus,
          .heatmap-option.selected:hover {
            font-weight: bold;
            background-color: ${foregroundColor};
            font-family: ${answer.font};
            line-height: 18px;
            color: ${backgroundColor} !important;
          }
          .heatmap-option:hover,
          .heatmap-option:focus {
            box-shadow: 0 0 1px 6px ${foregroundColor}15;
            background-color: ${foregroundColor}40;
            border-color: ${foregroundColor};
          }
          .marker {
            background-color: ${foregroundColor};
          }
          .heatmap-full-screen a {
            color: ${foregroundColor};
          }
          .heatmap-full-screen a:hover {
            color: ${foregroundColor};
          }
          .heatmap-full-screen .heatmapInstructions {
            font-family: ${question.font};
            font-size: 16px;
          }
          .heatmap-modal .ant-modal-footer .cancelButton {
            color: ${foregroundColor} !important;
            font-size: 14px;
            line-height: 18px;
            padding: 0 16.5px;
            background-color: #ffffff;
            width: 70;
            font-weight: 400;
            transition: none;
          }
          .heatmap-modal .ant-modal-footer .cancelButton:hover {
            font-weight: 600;
          }

          .heatmap-modal .ant-modal-footer .confirmButton {
            background-color: ${foregroundColor};
          }
          .heatmap-modal .ant-modal-footer .confirmButton:hover {
            background-color: ${foregroundColor};
          }
          .heatmap-modal .ant-modal-body .option-checkbox.selected,
          .heatmap-modal .ant-modal-body .option-radio.selected,
          .heatmap-modal .ant-modal-body .option-checkbox.selected,
          .heatmap-modal .ant-modal-body .option-radio.selected {
            border-color: ${foregroundColor};
          }
          .heatmap-modal .ant-modal-body .option-radio.selected .option-radio-inner.selected,
          .heatmap-modal .ant-modal-body .multiple-option.active .option-checkbox.selected,
          .heatmap-modal .ant-modal-body .option-radio.selected .option-radio-inner.selected,
          .heatmap-modal .ant-modal-body .option-checkbox.selected {
            background-color: ${foregroundColor};
          }

          .heatmap-modal .ant-modal-body .heatmap-textarea:focus,
          .heatmap-modal .ant-modal-body .heatmap-textarea:hover {
            border-color: ${foregroundColor};
            -webkit-box-shadow: 0 0 0 2px ${foregroundColor}33;
            box-shadow: 0 0 0 2px ${foregroundColor}33;
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    customization: { foregroundColor, backgroundColor, answer, question },
  } = state;
  return {
    foregroundColor,
    backgroundColor,
    answer,
    question,
  };
};

export default connect(mapStateToProps)(HeatmapStyle);
